import PropTypes from 'prop-types';

function MMPetsInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M9.46506 13.6252C9.46506 13.6252 7.66804 25.1775 8.21998 25.6481C8.77192 26.1188 13.3543 28.2752 21.9757 26.3027C28.9285 24.7111 32.7749 22.0712 34.1398 19.8035C34.6918 19.1617 28.3637 9.23535 28.3637 9.23535L9.46506 13.6252Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M19.6414 14.6201C24.8531 13.4121 28.7476 11.0071 28.3399 9.24834C27.9323 7.48962 23.3769 7.04318 18.1652 8.25119C12.9535 9.45919 9.05907 11.8642 9.46672 13.6229C9.87437 15.3816 14.4297 15.8281 19.6414 14.6201Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.4105 18.9179C24.7288 18.8443 25.0181 18.678 25.2418 18.4399C25.4655 18.2019 25.6137 17.9029 25.6675 17.5807C25.7212 17.2585 25.6783 16.9276 25.544 16.6298C25.4097 16.332 25.1901 16.0807 24.913 15.9078C24.6358 15.7348 24.3136 15.6479 23.9871 15.658C23.6606 15.6682 23.3445 15.7749 23.0786 15.9648C22.8128 16.1546 22.6092 16.419 22.4937 16.7246C22.3781 17.0301 22.3558 17.3631 22.4295 17.6814C22.4504 17.7726 22.4805 17.8615 22.5193 17.9466L17.8129 19.0377C17.8063 18.9442 17.7935 18.8513 17.7743 18.7596C17.6997 18.4504 17.5374 18.1693 17.3069 17.9501C17.0764 17.7309 16.7875 17.583 16.475 17.524C16.1624 17.4651 15.8395 17.4976 15.545 17.6178C15.2505 17.738 14.9969 17.9406 14.8148 18.2014C14.6327 18.4622 14.5298 18.77 14.5184 19.0879C14.507 19.4057 14.5877 19.7201 14.7507 19.9933C14.9137 20.2664 15.1521 20.4867 15.4372 20.6276C15.7224 20.7685 16.0421 20.8241 16.3581 20.7876C16.0553 20.8906 15.7889 21.0793 15.5913 21.3308C15.3936 21.5823 15.2733 21.8858 15.2448 22.2043C15.2164 22.5229 15.2811 22.8429 15.431 23.1255C15.5809 23.408 15.8097 23.6409 16.0895 23.7959C16.3693 23.9509 16.6881 24.0213 17.0071 23.9986C17.3261 23.9759 17.6317 23.861 17.8867 23.668C18.1418 23.4749 18.3352 23.2119 18.4436 22.911C18.552 22.6101 18.5707 22.2841 18.4974 21.9728C18.476 21.8822 18.4474 21.7935 18.4119 21.7075L23.1183 20.6165C23.1252 20.7099 23.138 20.8028 23.1568 20.8946C23.2304 21.2129 23.3967 21.5022 23.6348 21.7259C23.8728 21.9496 24.1718 22.0978 24.494 22.1516C24.8162 22.2054 25.1472 22.1624 25.4449 22.0281C25.7427 21.8938 25.994 21.6742 26.167 21.3971C26.3399 21.1199 26.4268 20.7978 26.4167 20.4713C26.4065 20.1447 26.2998 19.8286 26.1099 19.5627C25.9201 19.2969 25.6557 19.0933 25.3501 18.9778C25.0446 18.8622 24.7116 18.8399 24.3934 18.9136L24.4105 18.9179Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.9309 15.2511C13.3331 14.4681 17.9283 10.1809 25.3389 12.3758C19.5071 15.6533 12.9309 15.2511 12.9309 15.2511Z"
                fill="#2D2D2D"
            />
        </svg>
    );
}

export default MMPetsInactive;

MMPetsInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMPetsInactive.defaultProps = {
    className: null,
};
